import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { CoreSpaceState } from '@osos/shared/legacy-core';
import { SpaceEntryPresenterModel } from '@osos/shared/types';
import { Observable } from 'rxjs';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-my-spaces-list',
  templateUrl: './my-spaces-list.component.html',
  styleUrls: ['./my-spaces-list.component.scss'],
  standalone: false,
})
export class MySpacesListComponent implements OnInit {
  mySpaces$: Observable<SpaceEntryPresenterModel[]>;
  activeSpace$: Observable<SpaceEntryPresenterModel>;
  activeSpace: SpaceEntryPresenterModel;

  constructor(private store: Store) {}

  ngOnInit(): void {
    this.mySpaces$ = this.store.select(CoreSpaceState.mySpaces);
    this.activeSpace$ = this.store.select(CoreSpaceState.activeSpace);
    this.activeSpace$.subscribe((activeSpace) => {
      this.activeSpace = activeSpace;
    });
  }

  onSpaceChange(space: SpaceEntryPresenterModel): void {
    window.open(space.fullUrl, '_self');
  }
}
